import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ScanFace } from "lucide-react";
import { usePricingCalc } from "../features/billing/usePricingCalc";
import { PricingCalculator } from "../features/billing/PricingCalculator";
import { TiersTable } from "../features/billing/TiersTable";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { NeuButton } from "../components/neu/Neu";

export default function PricingPage() {
  const { t } = useTranslation();
  const { config, input, setInput, quotes } = usePricingCalc();

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-8 sm:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="neu flex h-12 w-12 items-center justify-center rounded-2xl p-0">
              <ScanFace className="h-6 w-6 text-primary" />
            </div>
            <p className="text-xl font-black">{t("app.name")}</p>
          </div>
          <div className="flex gap-2">
            <LangToggle />
            <ThemeToggle />
          </div>
        </div>

        <h1 className="text-4xl font-black tracking-tight sm:text-5xl">{t("pricingPage.title")}</h1>
        <p className="mt-3 max-w-2xl text-sm text-muted-foreground md:text-base">{t("pricingPage.subtitle")}</p>

        <div className="mt-8 grid gap-6">
          <PricingCalculator
            input={input}
            setInput={setInput}
            quotes={quotes}
            currency={config?.currency}
          />
          <TiersTable config={config} />
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-4">
          <Link to="/signup" data-testid="pricing-cta">
            <NeuButton variant="primary" className="px-8 py-4 text-base">
              {t("pricingPage.cta")}
            </NeuButton>
          </Link>
          <Link to="/login" className="text-xs font-semibold text-primary" data-testid="pricing-login">
            {t("reset.backToLogin")}
          </Link>
          <Link to="/terms" className="text-xs font-semibold text-primary" data-testid="pricing-terms">
            {t("legal.terms")}
          </Link>
          <Link to="/privacy" className="text-xs font-semibold text-primary" data-testid="pricing-privacy">
            {t("legal.privacy")}
          </Link>
        </div>
      </div>
    </div>
  );
}
